import React, { useCallback, useContext, useMemo } from "react";
import { Disease, brainBloodVesselDiseaseList, diseaseList, heartDiseaseList } from "../../../../../../domain/assessment/Disease";
import { diureticList } from "../../../../../../domain/assessment/Diuretic";
import { nursingDegreeList } from "../../../../../../domain/assessment/NursingDegree";
import { AssessmentInfoContext } from "../../../../../provider/CareRecipientConfigAssessmentInfoProvider";
import { InputSelectBox } from "../../../../common/input/InputSelectBox";
import { InputTextBox } from "../../../../common/input/InputTextBox";
import { CircleArrowIcon } from "../../../../common/icons/CircleArrowIcon";
import classNames from "classnames";

export const CareRecipientStatus = React.memo(function CareRecipientStatus() {
    const {
        nursingDegree,
        handleNursingDegreeChanged,
        diseases,
        handleSufferedDiseaseChanged,
        otherDiseases,
        handleOtherDiseasesChanged,
        diuretic,
        handleDiureticChanged
    } = useContext(AssessmentInfoContext);

    const isMatchedSufferedDisease = useCallback((disease: Disease) => diseases.includes(disease.value), [diseases]);

    const heartDiseaseConditionChecked = useMemo(() => (
        !!heartDiseaseList.filter(heartDisease => diseases.includes(heartDisease.value)).length
    ), [diseases]);

    const brainBloodVesselDiseaseConditionChecked = useMemo(() => (
        !!brainBloodVesselDiseaseList.filter(brainBloodVesselDisease => diseases.includes(brainBloodVesselDisease.value)).length
    ), [diseases]);

    return (
        <div className={"category"}>
            <div className={"title"}>介護状況</div>
            <div className="body">
                <div className="content">
                    <div className="label">要介護度</div>
                    <div className="addition">申請中の場合は見込み</div>
                    <div className="nursing_degree">
                        <InputSelectBox value={nursingDegree} list={nursingDegreeList} handleSelectBoxChanged={handleNursingDegreeChanged} />
                    </div>
                </div>
                <hr className="border"/>
                <div className="content">
                    <div className="label">疾患（既往を含む）</div>
                    <div className="addition">複数選択可</div>
                    {/* 通常の疾患 */}
                    <div className="disease">
                        {diseaseList.map((disease) => (
                            <div className="check_box_row" key={disease.label}>
                                <label className="check_box">
                                    <input type="checkbox" value={disease.value} checked={isMatchedSufferedDisease(disease)} onChange={handleSufferedDiseaseChanged} />
                                    <span className="icon_checked"/>
                                    {disease.label}
                                </label>
                            </div>
                        ))}
                    </div>
                    {/* 心疾患 */}
                    <div className={classNames("disease_label", { "disease_checked": heartDiseaseConditionChecked })}>
                        <CircleArrowIcon rotateZ={0} />
                        <span>心疾患</span>
                    </div>
                    <div className={"disease"}>
                        {heartDiseaseList.map((disease) => (
                            <div className="check_box_row" key={disease.label}>
                                <label className="check_box">
                                    <input type="checkbox" value={disease.value} checked={isMatchedSufferedDisease(disease)} onChange={handleSufferedDiseaseChanged} />
                                    <span className="icon_checked"/>
                                    {disease.label}
                                </label>
                            </div>
                        ))}
                    </div>
                    {/* 脳血管疾患 */}
                    <div className={classNames("disease_label", { "disease_checked": brainBloodVesselDiseaseConditionChecked })}>
                        <CircleArrowIcon rotateZ={0} />
                        <span>脳血管疾患</span>
                    </div>
                    <div className={"disease"}>
                        {brainBloodVesselDiseaseList.map((disease) => (
                            <div className="check_box_row" key={disease.label}>
                                <label className="check_box">
                                    <input type="checkbox" value={disease.value} checked={isMatchedSufferedDisease(disease)} onChange={handleSufferedDiseaseChanged} />
                                    <span className="icon_checked"/>
                                    {disease.label}
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
                <hr className="border"/>
                <div className="content">
                    <div className="label">その他疾患（既往を含む）</div>
                    <div className="other_disease">
                        <InputTextBox placeholder={"例：ヘルニア、偏頭痛など"} value={otherDiseases} handleTextChanged={handleOtherDiseasesChanged} />
                    </div>
                    <div className="label">利尿作用のある服用薬</div>
                    <div className="diuretic">
                        <InputSelectBox value={diuretic} list={diureticList} handleSelectBoxChanged={handleDiureticChanged} />
                    </div>
                </div>
            </div>
        </div>
    );
});
